import React from 'react';
import { Row, Col,Container,Button } from 'react-bootstrap';
import AboutBannerImg from '../assets/images/about-banner.png';
import { useNavigate } from "react-router-dom";


const AboutBanner = ({ section, imageUrl }) => {
    const navigate = useNavigate();
  
  const title = section?.title || 'Your <span>trusted</span> home<br>for getting home';
  const description = section?.description ||
    'Jambobay is the housing super app — an ecosystem of products and services...';
  const subDescription = section?.sub_description || 'Jambobay has been helping people get homes.';

  return (
    <section className="about-banner-section">
      <Container>
          <Row>
            <Col md={12} className='about-content-box align-self-center justify-content-center'>
              <div className="about-content">
                <h1
              className="about-title"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <p
              className="about-description"
              dangerouslySetInnerHTML={{ __html: description }}
            />
                 <Button onClick={()=>navigate('/')}
                      className="custom-bttn"
                    >
                      Learn More
                    </Button>
                 <img 
                src={imageUrl || AboutBannerImg}
                  alt="Modern House" 
                  className="house-img"
                />
              </div>
            </Col>
          </Row>
        </Container>
    </section>
  );
};

export default AboutBanner;